export function visibleActiveOnlyInput(doc = document) {
  const inputs = Array.from(doc.querySelectorAll('input[name="active_only"]'));
  return inputs.find((input) => input.offsetParent !== null) || inputs[0];
}

export function activeOnlyChecked({ root = document, doc = document } = {}) {
  const scoped = root?.querySelector?.('input[name="active_only"]');
  if (scoped) {
    return Boolean(root.querySelector('input[name="active_only"]:checked'));
  }
  return Boolean(visibleActiveOnlyInput(doc)?.checked);
}

export function appendActiveOnly(params, { root = document, doc = document } = {}) {
  params.set("active_only", activeOnlyChecked({ root, doc }) ? "1" : "0");
}

export function resetActiveOnly(doc = document) {
  doc.querySelectorAll('input[name="active_only"]').forEach((input) => {
    input.checked = true;
  });
}

export function setActiveOnly(checked, doc = document) {
  doc.querySelectorAll('input[name="active_only"]').forEach((input) => {
    input.checked = checked;
  });
}
